module.exports = ol.source.XYZ;